import { MobileOpCode, QueryGetAccessEventsForTenantArgs } from 'graphql/generated/graphqlTypes';
import {
  GET_ACCESS_EVENTS_FOR_TENANT,
  GET_ALL_VISITORS_CARDS,
  GET_CARDS,
  GET_CURRENT_HOST,
  GET_CURRENT_TENANT,
  GET_CURRENT_VISITOR,
  GET_DOORS_FOR_TENANT_WITH_LOCATIONS,
  GET_DOORS_FOR_TENANT_WITH_OFFICE_MODE,
  GET_LOCATIONS_WITH_DOORS_FOR_TENANT,
  GET_MFA_PREFERENCE,
  GET_REST_API_KEYS,
  GET_TENANT_LEGAL_DOCUMENTS,
  GET_TENANT_NAME,
  GET_TENANT_REGISTRATION_INFO,
  GET_VISITOR_GROUPS_FOR_TENANT,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_ACCESS_GRANTS,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_IS_OFFICE_MODE_ENABLED,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
  GET_VISITOR_GROUPS_WITH_PERMISSIONS
} from 'graphql/queries';
import {
  GET_ACCESS_EVENTS_FOR_TENANT as GET_ACCESS_EVENTS_FOR_TENANT_V2,
  GET_ADMIN_VISITOR_GROUPS_FOR_TENANT,
  GET_ALL_VISITORS_FOR_TENANT,
  GET_ALL_VISITORS_GROUPS,
  GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS,
  GET_ALL_VISITORS_VISITOR_GROUPS,
  GET_DOORS_WITHOUT_NESTED_RESOLVERS,
  GET_LOCATIONS_WITHOUT_NESTED_RESOLVERS,
  GET_QR_CODE_VISITS_FOR_TENANT,
  GET_VISITOR_DETAILS,
  GET_VISITOR_DETAILS_DOORS,
  GET_VISITOR_DETAILS_LOCK_GROUPS,
  GET_VISITOR_DETAILS_VISITOR_GROUPS,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_SCHEDULES,
  GET_VISITORS_WITHOUT_NESTED_RESOLVERS
} from 'graphql/v2/queries';
import { mockedGetAdminVisitorGroupsForTenantDataForQuery } from 'mocks/graphqlApollo/query/getAdminVisitorGroupsForTenant';
import { mockedGetAllVisitorsForTenantData } from 'mocks/graphqlApollo/query/getAllVisitorsForTenant';
import { mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getAllVisitorsGroupsWithoutNestedResolvers';
import { mockedGetCardsDataForQuery } from 'mocks/graphqlApollo/query/getCards';
import { mockedGetCurrentTenantDataForQuery } from 'mocks/graphqlApollo/query/getCurrentTenant';
import { mockedGetDoorsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getDoorsWithoutNestedResolvers';
import { mockedGetLocationsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getLocationsWithoutNestedResolvers';
import { mockedGetMfaPreferenceDataForQuery } from 'mocks/graphqlApollo/query/getMfaPreferenceDataForQuery';
import { mockedGetQrCodeVisitsForTenantData } from 'mocks/graphqlApollo/query/getQrCodeVisitsForTenant';
import { mockedGetRestAPIKeysDataForQuery } from 'mocks/graphqlApollo/query/getRestAPIKeys';
import { mockedGetTenantLegalDocumentsDataForQuery } from 'mocks/graphqlApollo/query/getTenantLegalDocuments';
import { mockedGetTenantNameDataForQuery } from 'mocks/graphqlApollo/query/getTenantName';
import { mockedGetTenantRegistrationInfoDataForQuery } from 'mocks/graphqlApollo/query/getTenantRegistrationInfo';
import { mockedGetVisitorByIdDataForQuery } from 'mocks/graphqlApollo/query/getVisitorById';
import { mockedGetVisitorDetailsData } from 'mocks/graphqlApollo/query/getVisitorDetails';
import { mockedGetVisitorDetailsDoorsDataForQuery } from 'mocks/graphqlApollo/query/getVisitorDetailsDoors';
import { mockedGetVisitorDetailsLockGroupsDataForQuery } from 'mocks/graphqlApollo/query/getVisitorDetailsLockGroups';
import { mockedGetVisitorDetailsVisitorGroupsDataForQuery } from 'mocks/graphqlApollo/query/getVisitorDetailsVisitorGroups';
import { mockedGetVisitorsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getVisitorsWithoutNestedResolvers';
import { mockVisitorsWithGroups } from 'mocks/graphqlMocks/visitorFixtures';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import {
  mockedGetAccessEventsForTenantDataForQueryFirstFetch,
  mockedGetAccessEventsForTenantDataForQuerySecondFetch,
  mockedGetAccessEventsForTenantDataForTimeWindow
} from '../graphqlApollo/query/getAccessEventsForTenant';
import {
  mockedGetCurrentVisitorAdminDataForQuery,
  mockedGetCurrentVisitorUnitTestsDataForQuery
} from '../graphqlApollo/query/getCurrentVisitor';
import { mockedGetDoorsForTenantWithLocationsDataUnitTests } from '../graphqlApollo/query/getDoorsForTenantWithLocations';
import { mockedGetDoorsWithOfficeDaysForTenantDataUnitTests } from '../graphqlApollo/query/getDoorsForTenantWithOfficeMode';
import { mockedGetLocationWithDoorsForTenantDataUnitTests } from '../graphqlApollo/query/getLocationWithDoorsForTenant';
import { mockedGetVisitorGroupsForTenantWithAccessGrantsDataDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithAccessGrants';
import { mockedGetVisitorGroupsForTenantWithIsAdminGroupDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsAdminGroupDataForQuery';
import { mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsOfficeModeEnabled';
import {
  mockedGetVisitorGroupsForTenant,
  mockedGetVisitorGroupsForTenantWithMembersAndRoleDataForQuery
} from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndRole';
import {
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery,
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery1,
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters
} from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndTypes';
import { mockedGetVisitorGroupsWithSchedulesForTenantDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithSchedules';
import { mockedGetVisitorGroupsForTenantWithTypesDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithTypes';

const visitorDetailsQueries = mockVisitorsWithGroups.map((visitor) => ({
  id: visitor.id,
  data: mockedGetVisitorDetailsData(visitor)
}));

export const queries = [
  {
    request: {
      query: GET_CURRENT_HOST
    },
    newData: () => ({
      data: mockedGetCurrentVisitorAdminDataForQuery
    })
  },
  {
    request: {
      query: GET_CURRENT_TENANT
    },
    newData: () => ({
      data: mockedGetCurrentTenantDataForQuery
    })
  },
  {
    request: {
      query: GET_CURRENT_VISITOR
    },
    newData: () => ({
      data: mockedGetCurrentVisitorUnitTestsDataForQuery
    })
  },
  {
    request: {
      query: GET_DOORS_FOR_TENANT_WITH_OFFICE_MODE
    },
    newData: () => ({
      data: mockedGetDoorsWithOfficeDaysForTenantDataUnitTests
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndRoleDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery1
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_WITH_PERMISSIONS,
      variables: {
        filter: {
          type: VisitorGroupType.AzureAd
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithIsAdminGroupDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_SCHEDULES
    },
    newData: () => ({
      data: mockedGetVisitorGroupsWithSchedulesForTenantDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithTypesDataForQuery
    })
  },
  {
    request: {
      query: GET_ACCESS_EVENTS_FOR_TENANT,
      variables: { filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] } }
    },
    newData: () => ({
      data: mockedGetAccessEventsForTenantDataForQueryFirstFetch
    })
  },
  {
    request: {
      query: GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        nextToken: 'mockedNextToken',
        filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    newData: () => ({
      data: mockedGetAccessEventsForTenantDataForQuerySecondFetch
    })
  },
  // The two entries above are registered against the *legacy* access events query; the v2 hooks send
  // a different document, so they need their own mock. The dashboard charts query a rolling window
  // whose timestamps can never be matched exactly, so they are matched on the presence of a
  // `dateRange` instead and served events generated for whatever window and actions they asked for.
  {
    request: { query: GET_ACCESS_EVENTS_FOR_TENANT_V2 },
    variableMatcher: (variables: QueryGetAccessEventsForTenantArgs) => Boolean(variables?.filter?.dateRange),
    // every dashboard chart queries this window, so the mock has to stay usable for all of them
    maxUsageCount: Number.POSITIVE_INFINITY,
    result: (variables: QueryGetAccessEventsForTenantArgs) => ({
      data: mockedGetAccessEventsForTenantDataForTimeWindow(variables?.filter)
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_IS_OFFICE_MODE_ENABLED
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataForQuery
    })
  },
  {
    request: {
      query: GET_LOCATIONS_WITH_DOORS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetLocationWithDoorsForTenantDataUnitTests
    })
  },
  {
    request: {
      query: GET_DOORS_FOR_TENANT_WITH_LOCATIONS
    },
    newData: () => ({
      data: mockedGetDoorsForTenantWithLocationsDataUnitTests
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_ACCESS_GRANTS
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithAccessGrantsDataDataForQuery
    })
  },
  {
    request: {
      query: GET_TENANT_LEGAL_DOCUMENTS
    },
    newData: () => ({
      data: mockedGetTenantLegalDocumentsDataForQuery
    })
  },
  {
    request: {
      query: GET_TENANT_REGISTRATION_INFO
    },
    newData: () => ({
      data: mockedGetTenantRegistrationInfoDataForQuery
    })
  },
  {
    request: {
      query: GET_REST_API_KEYS
    },
    newData: () => ({
      data: mockedGetRestAPIKeysDataForQuery
    })
  },
  {
    request: {
      query: GET_TENANT_NAME,
      variables: {
        azureTenantId: 'mockedAzureTenantId'
      }
    },
    newData: () => ({
      data: mockedGetTenantNameDataForQuery
    })
  },
  {
    request: {
      query: GET_MFA_PREFERENCE
    },
    newData: () => ({
      data: mockedGetMfaPreferenceDataForQuery
    })
  },
  {
    request: {
      query: GET_CARDS
    },
    newData: () => ({
      data: mockedGetCardsDataForQuery
    })
  },
  {
    request: {
      query: GET_ADMIN_VISITOR_GROUPS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetAdminVisitorGroupsForTenantDataForQuery
    })
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters
    })
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITORS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetVisitorsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: GET_LOCATIONS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetLocationsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: GET_DOORS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetDoorsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS,
      variables: { filter: { id: 'mockedVisitorGroupIdExternalUsers1' } }
    },
    newData: () => ({
      data: {
        getVisitorGroupsForTenant: [
          generateMockVisitorGroup({
            id: 'mockedVisitorGroupIdExternalUsers1',
            name: 'co-contractors1',
            type: VisitorGroupType.CoContractors
          })
        ]
      }
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
      variables: { filter: { id: 'mockedVisitorGroupIdExternalUsers1' } }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndRoleDataForQuery
    })
  },
  {
    request: {
      query: GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Administrators
        }
      }
    },
    newData: () => ({ data: mockedGetVisitorGroupsForTenant })
  },
  {
    request: {
      query: GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    newData: () => ({ data: mockedGetVisitorGroupsForTenant })
  },
  {
    request: {
      query: GET_VISITOR_DETAILS,
      variables: {
        id: 'mockedVisitorIdExternalUser6'
      }
    },
    newData: () => ({ data: mockedGetVisitorByIdDataForQuery })
  },
  ...visitorDetailsQueries.map(({ id, data }) => ({
    request: {
      query: GET_VISITOR_DETAILS,
      variables: { id }
    },
    newData: () => ({ data })
  })),
  {
    request: {
      query: GET_VISITOR_DETAILS_VISITOR_GROUPS
    },
    newData: () => ({
      data: mockedGetVisitorDetailsVisitorGroupsDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITOR_DETAILS_LOCK_GROUPS
    },
    newData: () => ({
      data: mockedGetVisitorDetailsLockGroupsDataForQuery
    })
  },
  {
    request: {
      query: GET_VISITOR_DETAILS_DOORS
    },
    newData: () => ({
      data: mockedGetVisitorDetailsDoorsDataForQuery
    })
  },
  {
    request: {
      query: GET_ALL_VISITORS_CARDS
    },
    newData: () => ({
      data: mockedGetCardsDataForQuery
    })
  },
  {
    request: {
      query: GET_ALL_VISITORS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetAllVisitorsForTenantData
    })
  },
  {
    request: {
      query: GET_QR_CODE_VISITS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetQrCodeVisitsForTenantData
    })
  }
];
